import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types';
import '../Workflow.scss'
import WorkflowTask from '../../../../../components/library/workflow-tasks/WorkflowTask'
import { useTaskStatus } from '../../hooks/useTaskStatusHook';
import { WorkflowTasks } from '../../../services/WorkflowTasks';
import { TaskStatus } from '../../../services/TaskStatus';
import { useTicketStatus } from '../../hooks/useTicketStatusHook';
import { useInterviewInfo } from '../../hooks/useInterviewInfoHook';
import {shallowEqual} from 'react-redux';
import WorkflowTaskDescriptionWithHelp from '../../../../../components/library/workflow-tasks/WorkflowTaskDescriptionWithHelp';
import classnames from 'classnames';
import HrbTranslate from '../../../../../components/language/HrbTranslate'
import Button from '../../../../../components/library/buttons/Button';
import TicketActions from '../../../../../store/ticketRedux';
import { trackEvent, HeapEvents } from '../../../../../services/util/AnalyticsUtil';
import TaskErrorText from '../../../../../components/library/workflow-tasks/TaskErrorText';
import VerticalNameChildren from '../../../../../components/library/layout/VerticalNameChildren';
import DateTime from '../../../../../components/library/common/DateTime';
import EmdashText from '../../../../../components/library/common/EmdashText';
import { completeTicketWorkflowTask } from '../../../../../services/tickets/ticketWorkflowTask';
import Lang from '../../../../../components/language/services/Lang'
import tickMark from '../../../../../images/Tick.svg'
import crossMark from '../../../../../images/Cross.svg'

const PreparePaymentRteTask = (props) => {
    const [reviewTaskList, setReviewBaseTaskList] = useState([WorkflowTasks.RETURN_REVIEWED])
    const [additionalReviewTaskList, setAdditionalReviewTaskList] = useState([]);
    const [baseStatus, taskCompletions] = useTaskStatus(props.ticket, [WorkflowTasks.PAYMENT_PREPARED]);
    const [status, setStatus] = useState(baseStatus);
    const [stateTasks] = useTicketStatus(props.ticket);
    const [hasCompletionError, setHasCompletionError] = useState(false);
    const [completion, setCompletion] = useState({})
    const [completionData, setCompletionData] = useState({})
    const dispatch = useDispatch();
    const [reviewStatus, reviewCompletions] = useTaskStatus(props.ticket, reviewTaskList);
    const [prepareStatus, prepareCompletions] = useTaskStatus(props.ticket, [WorkflowTasks.RETURN_PREPARED])
    const [additionalReviewStatus, additionalReviewCompletions] = useTaskStatus(props.ticket, additionalReviewTaskList, status);    
    const [returnType, , province, primaryName, spouseName] = useInterviewInfo(props.ticket);
    const [isPendingCompletion, setIsPendingCompletion] = useState(false);

    useEffect(() => {
        if (province === 'QC') {
            setReviewBaseTaskList([WorkflowTasks.RETURN_REVIEWED, WorkflowTasks.RETURN_REVIEWED_RQ])
        }
    }, [province])

    // We need Return Prepared completion data to pull the list of additional docs tasks that need to be signed in Return Review stage. 
    useEffect(() => {
        var prepComp = (prepareCompletions || []).filter(c => c.status !== TaskStatus.INVALID)
        var pc = prepComp.length > 0 ? prepComp[0] : {}
        if (pc && pc.completionData) {
            var cd = JSON.parse(pc.completionData);
            var addlDocs = (cd ? cd.additionalDocuments : null) || {}
            var additionalTaskIds = Object.keys(addlDocs).map(k => k)
                .filter(l => !l.startsWith('T1_') && !l.startsWith('TaxStory_') && !l.startsWith('T183_') && !l.startsWith('TP1_') && !l.startsWith('TP1000'));
            if (!shallowEqual(additionalReviewTaskList, additionalTaskIds)) {
                setAdditionalReviewTaskList(additionalTaskIds);
            }
        }
    }, [prepareCompletions, status, prepareStatus]);


    useEffect(() => {
       let tcs = taskCompletions || []
       let completionTask = tcs.find(x => x.status !== TaskStatus.INVALID
           && x.workflowTaskId === WorkflowTasks.PAYMENT_PREPARED)
        
       var bStatus = baseStatus;
       if (baseStatus !== TaskStatus.COMPLETE && (props.ticket)) { 
            var reviewReturnStatus = additionalReviewTaskList.length > 0 ?
                reviewStatus === TaskStatus.COMPLETE && additionalReviewStatus === TaskStatus.COMPLETE:
                reviewStatus === TaskStatus.COMPLETE
           if (reviewReturnStatus) {
               bStatus = TaskStatus.IN_PROGRESS
           }
           if (completionTask && completionTask.status === TaskStatus.COMPLETE) {
               setCompletion(completionTask)
               var cdata = JSON.parse(completionTask.completionData)
               setCompletionData(cdata)
               bStatus = TaskStatus.COMPLETE
           }
       }

       setStatus( hasCompletionError ? TaskStatus.ERROR : bStatus);
    }, [baseStatus, stateTasks, hasCompletionError, taskCompletions])

    const getPaymentPreparedDate = () => {
        var completion, data, cs;

        cs = taskCompletions.filter(c => c.status === TaskStatus.COMPLETE && c.workflowTaskId === WorkflowTasks.PAYMENT_PREPARED)
        completion = cs.length > 0 ? cs[0] : null;

        if (completion && completion.completionData) {
            data = JSON.parse(completion.completionData);                 
            return (data || {}).PreparePaymentDate;
        }
    }
    
    const handlePrepPaymentAction = async () => {
        setIsPendingCompletion(true)
        setHasCompletionError(false);

        var workflowTask = {
            "workflowTask": WorkflowTasks.PAYMENT_PREPARED,
            "status": TaskStatus.COMPLETE,
            "completionData": JSON.stringify({CompletionType: 'MANUAL'})
        }

        var response = await completeTicketWorkflowTask(props.ticket.id, workflowTask);
        if (response) {
            if (response.isSuccess) {
                dispatch(TicketActions.getTicket(props.ticket.id))
                trackEvent(HeapEvents.COMPLETE_PREPARE_Payment, props.ticket.id)
                setIsPendingCompletion(false)
            } 
        } else {
            setHasCompletionError(true)
            setIsPendingCompletion(false)
        }
    }

    const createLink = (urlKey, titleKey) => (
        <a href={Lang.getCurrentValue(urlKey)} target='_blank' rel='noreferrer noopener'>
            <HrbTranslate text={titleKey} />
        </a>
    )

    const getPOMSelectionStatus = (filer) => {
        var completion, data, cs;
        var workFlowTask;
        if (province === 'QC') workFlowTask = WorkflowTasks.RETURN_REVIEWED_RQ
        else workFlowTask = WorkflowTasks.RETURN_REVIEWED

        cs = reviewCompletions.filter(c => c.status !== TaskStatus.INVALID && c.workflowTaskId === workFlowTask)
        completion = cs.length > 0 ? cs[0] : null;

        if (completion && completion.completionData) {
            data = JSON.parse(completion.completionData);
            if (filer === 'PRIMARY') {
                return (data || {}).primaryPOMSelection;
            } else {
                return (data || {}).spousePOMSelection;
            }
        }
    }

    return (
        <WorkflowTask status={status} taskId={WorkflowTasks.PAYMENT_PREPARED}>
            <div className='columns'>
                <WorkflowTaskDescriptionWithHelp
                    helpKey='0ProSupport/VDOPro/PaymentReview.htm'
                    descriptions={['PreparePaymentRteTask.Description']}
                />
            </div>
            {props.isPOMEligible &&
                    <div>
                        <div className='columns prep-section'>
                            <div className='column is-offset-1 is-8'>
                                <p className='p2'>
                                    <HrbTranslate text={'PreparePaymentRteTask.pomDescription'}
                                        params={{
                                            LearnMore: createLink('PreparePaymentRteTask.pomLearnMoreLink', 'PreparePaymentRteTask.pomLearnMore')
                                        }} />
                                </p>
                            </div>
                        </div>
                        <div className='columns prep-section'>
                            <div className='column is-offset-1 is-4'>
                                <div style={{ marginBottom: '5px' }} >
                                    {primaryName}
                                </div>
                                <p className='p2'>
                                    <img src={getPOMSelectionStatus('PRIMARY') ? tickMark : crossMark} style={{ position: 'relative', top: '1px' }} />
                                    <span style={{ paddingLeft: '10px' }} >
                                        <HrbTranslate text={'PreparePaymentRteTask.pomSelectionDesc'} />
                                    </span>
                                </p>
                            </div>
                            {returnType === 'coupled' &&
                                <div className='column is-4'>
                                    <div style={{ marginBottom: '5px' }} >
                                        {spouseName}
                                    </div>
                                    <p className='p2'>
                                        <img src={getPOMSelectionStatus('SPOUSE') ? tickMark : crossMark} style={{ position: 'relative', top: '1px' }} />
                                        <span style={{ paddingLeft: '10px' }} >
                                            <HrbTranslate text={'PreparePaymentRteTask.pomSelectionDesc'} />
                                        </span>
                                    </p>
                                </div>
                            }
                        </div>
                        <div className='columns'>
                            <div className='column is-10 is-offset-1 prep-border small-margins' />
                        </div>
                    </div>
            }
            <div className='columns prep-section'>
                <div className='column is-offset-1 is-8'>
                    <p className='p2'>
                        <HrbTranslate text={'PreparePaymentRteTask.PreparePaymentDescription'}/>
                    </p>
                </div>
            </div>
            <div className='columns prep-section'>
                <div className='column is-offset-1 is-10'>                    
                    {props.ticket &&
                    <div className='step-center-container'>
                        <Button
                            elementId='prepare-done-btn'
                            labelKey='PreparePaymentRteTask.PreparePaymentBtn'
                            buttonStyles='primary'
                            onClick={handlePrepPaymentAction}
                            disabled={(status !== TaskStatus.IN_PROGRESS && status !== TaskStatus.ERROR)}
                            loading={isPendingCompletion}
                            />                                                    
                    </div>
                    }
                    {hasCompletionError &&
                        <TaskErrorText errorKey='PreparePaymentRteTask.ErrorSubmit' />
                    }
                </div>
            </div>
            <div className='columns prep-section'>
                <div className='column is-offset-1 is-8'>
                    <p className='p2'>
                        <HrbTranslate text={'PreparePaymentRteTask.PreparePaymentResetInfo'}
                            params={{
                                LearnMore: createLink('PreparePaymentRteTask.PreparePaymentResetMoreInfoLink', 'PreparePaymentRteTask.PreparePaymentResetMoreInfoLinkDesc')
                            }} />
                    </p>
                </div>
            </div>
            <div className='columns'>
                <div className='column is-10 is-offset-1 prep-border small-margins' />
            </div>
            <div className='columns'>
                <div className={classnames('column is-offset-1', 'is-10')}>
                    <VerticalNameChildren
                        textKey="PreparePaymentRteTask.PreparedOn"
                        loading={!props.ticket}>
                        <p className='p1 medium-weight'>
                            <DateTime dateAndTime includeSeconds value={getPaymentPreparedDate()} fallbackValue={<EmdashText />} />
                        </p>
                    </VerticalNameChildren>
                </div>
            </div>
        </WorkflowTask>
    );
}

PreparePaymentRteTask.whyDidYouRender = false;

PreparePaymentRteTask.propTypes = {
    ticket: PropTypes.object,
    isPOMEligible: PropTypes.bool
}

export default PreparePaymentRteTask